// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Alert_wrapper__Xbo8s","heading":"Alert_heading__BPXBE","text":"Alert_text__TvrmE"};